<template>
  <div class="choose-community">
    <a-spin tip="加载中..." :spinning="loading" v-if="isShow">
      <a-row :gutter="[0, 32]">
        <a-col class="title">选择社区</a-col>
        <a-col>
          <a-row :gutter="[0, 32]">
            <a-col v-for="value in data" :key="value.id" @click="selectCommunity(value)">
              <a-row class="item" :gutter="[0, 16]">
                <a-col>{{value.name}}</a-col>
                <a-col>{{value.province}} / {{value.city}} / {{value.area}}</a-col>
              </a-row>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-spin>
  </div>
</template>

<script>
  import UserService from '@/io/user.js';
  import CommunityService from '@/io/community.js';

  export default {
    name: 'ChooseCommunity',
    props: {
      layer: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        data: [],
        loading: true,
        isShow: this.layer
      }
    },
    mounted () {
      this.initData().then(() => {
        let id = this.$getCookie('communityId') * 1;
        if (id && !this.layer) {
          let data = this.data.filter(val => val.id === id);
          if (data.length) {
            this.selectCommunity(data[0]);
          } else {
            this.isShow = true;
          }
        } else {
          this.isShow = true;
        }
      });
    },
    methods: {
      selectCommunity(data) {
        this.$setCookie('communityId', data.id);
        this.$store.commit('setCommunity', data);
        this.$emit('selected');
      },
      initUserInfo() {
        let hideLoading = this.$message.loading({content: '初始化管理员信息', duration: 0});
        return UserService.userInfo().then(res => {
          this.$store.commit('setUserInfo', res);
        }).catch(err => {}).finally(() => {
          hideLoading();
        });
      },
      initData() {
        let communityData = [];
        this.loading = true;
        return CommunityService.listPage().then(res => {
          communityData = res;
          if (this.layer) {
            return this.initUserInfo();
          }
        }).then(res => {
          let ids = this.$store.state.userInfo.userCommunity.map(val => val.community_id);
          this.data = communityData.filter(val => ids.indexOf(val.id) > -1);
        }).catch(err => {}).finally(() => {
          this.loading = false;
        });
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '../../assets/styles/tools.less';
  .choose-community {
    text-align: center;
    .title {
      font-size: 24px;
      font-weight: bold;
    }
    .item {
      padding: @padding-lg 0;
      transition: all @animation-duration-base;
      border: 1px solid @border-color-base;
      cursor: pointer;
      &:hover {
        background-color: @primary-color;
        color: @white;
        border-color: @primary-color;
      }
      & > .ant-col {
        &:nth-of-type(1) {
          font-size: @font-size-xl;
        }
        &:nth-of-type(2) {
          font-size: @font-size-lg;
          opacity: .6;
        }
      }
    }
  }
</style>